export default "/_next/static/media/image-10-1024x292.b5eceab9d48a5acd75baa4dd0afdd5bb.png";